import { createFileRoute } from "@tanstack/react-router";
import { TopicPage } from "@/components/site/TopicPage";
import logoAsset from "@/assets/lifewestway-logo.png.asset.json";
import { makeSeoDescription } from "@/lib/seo-description";

const SITE = "https://lifewestway.com";
const TITLE = "Expat Personal Finance 2026 | LifeWestWay";
const DESC = "Banking, credit-building, cross-border investing, and long-term wealth strategies for expats.";
const URL_ = `${SITE}/finance`;
const IMAGE = `${SITE}${logoAsset.url}`;

export const Route = createFileRoute("/finance")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: makeSeoDescription(DESC) },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: makeSeoDescription(DESC) },
      { property: "og:type", content: "article" },
      { property: "og:url", content: URL_ },
      { property: "og:image", content: IMAGE },
      { property: "og:image:alt", content: "LifeWestWay" },
      { property: "og:site_name", content: "LifeWestWay" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: makeSeoDescription(DESC) },
      { name: "twitter:image", content: IMAGE },
    ],
    links: [{ rel: "canonical", href: "https://lifewestway.com/finance" }],
  }),
  component: () => (
    <TopicPage
      topic="Finance"
      intro="Open the right accounts, build local credit, and structure investments for a global life."
    />
  ),
});
